// extracted by mini-css-extract-plugin
module.exports = {"block":"block--CDezI","button":"button--yWxRA","labels":"labels--SlYHK","tag":"tag--WCyad","statesblk":"statesblk---O4mG","row":"row--t+en0","long":"long--npQt+"};